module.exports = __webpack_public_path__ + "static/media/ChineseCloisonne.bdcf471f.jpg";